import type { RouteLocationNormalizedGeneric } from 'vue-router'

import { useTutorBillingStore, TUTOR_BILLING_DEFAULT_PER_PAGE, queryToFilters } from '@pages/tutor-billing'
import { MAX_PER_PAGE, toPaginationValue } from '@shared/lib/routes'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useTutorBillingStore()

  store.setFilters(queryToFilters(to.query))
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, TUTOR_BILLING_DEFAULT_PER_PAGE, MAX_PER_PAGE))
})
